import { ErrorState } from "@/shared/layout";

export function ErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <div data-theme="accela-donutwork" className="min-h-screen bg-base-200">
      <ErrorState
        title="Connection error"
        message="Unable to load your account. Check the API configuration and retry."
        action={
          <button className="btn btn-primary btn-sm" onClick={onRetry}>
            Retry
          </button>
        }
      />
    </div>
  );
}
